/* -------------------------------------------------------------------------- */
/*                            Schema Agents                                   */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const monitoringUser = new schema.Entity('monitoringUsers', {}, { idAttribute: 'userName' });
export const monitoringUsers = new schema.Array(monitoringUser);
